var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H8C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8V16C6 16.5304 6.21071 17.0391 6.58579 17.4142C6.96086 17.7893 7.46957 18 8 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V8C18 7.46957 17.7893 6.96086 17.4142 6.58579C17.0391 6.21071 16.5304 6 16 6ZM8 7.33333H16C16.1768 7.33333 16.3464 7.40357 16.4714 7.5286C16.5964 7.65362 16.6667 7.82319 16.6667 8V13.5733L14.5333 11.7533C14.2028 11.4814 13.788 11.3327 13.36 11.3327C12.932 11.3327 12.5172 11.4814 12.1867 11.7533L7.33333 15.8V8C7.33333 7.82319 7.40357 7.65362 7.5286 7.5286C7.65362 7.40357 7.82319 7.33333 8 7.33333Z",
    fill: "#54595E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 10.6666C9.88566 10.6666 10.3334 10.2189 10.3334 9.66663C10.3334 9.11434 9.88566 8.66663 9.33337 8.66663C8.78109 8.66663 8.33337 9.11434 8.33337 9.66663C8.33337 10.2189 8.78109 10.6666 9.33337 10.6666Z",
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachImage);
export default __webpack_public_path__ + "static/media/attach-image.f0e048fa3cf12bad7b8a0dd231d0c116.svg";
export { ForwardRef as ReactComponent };